'use client';

/**
 * Просмотры при переходах внутри сайта (#212).
 *
 * Сайт одностраничный: переход по ссылке меняет адрес без загрузки
 * страницы, и сама Метрика этого не видит. Замерено на проде 25.09:
 * переход с /gpt/write-essay на /gpt/write-mail не отправил ни одного
 * запроса `watch`. Визит из поиска, прошедший по трём страницам,
 * считался визитом на одну страницу и часто отказом.
 *
 * Первый показ не отправляется: его уже засчитал `init` при загрузке.
 * Источником перехода передаётся предыдущий адрес, иначе Метрика взяла бы
 * исходный `document.referrer` (поисковик) на каждый шаг.
 *
 * Прошлый адрес хранится в модуле, а не в состоянии компонента. Витрина
 * и кабинет живут в разных layout, и при переходе между ними компонент
 * пересоздаётся: с памятью внутри него первый экран кабинета после
 * витрины не засчитывался бы никогда, а это ровно тот шаг воронки,
 * ради которого задача и заведена.
 *
 * Строка запроса не передаётся: в кабинете в ней бывают номера папок и
 * текст первого вопроса (`/dashboard/chat/…?q=`), а это не наше дело
 * отправлять в чужую аналитику.
 */

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { cel, razdel, ymId } from '@/lib/metrika-celi';

let proshlyj: string | null = null;

/** Разделы, открытие которых считается целью «смотрел тарифы». */
const TARIFY = /(^|\/)(pricing|tarify)$/;

export function MetrikaPerehody() {
  const pathname = usePathname();

  useEffect(() => {
    const id = ymId();
    if (!id) return;
    const url = `${window.location.origin}${pathname}`;
    const byl = proshlyj;
    proshlyj = url;
    if (byl === url) return;
    if (byl !== null) window.ym?.(id, 'hit', url, { referer: byl, title: document.title });
    if (TARIFY.test(pathname)) cel('pricing_open', { stranica: razdel(pathname) });
  }, [pathname]);

  return null;
}
